import type { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { AssistantSettingsHttp } from './assistant-settings.http';
import { AssistantSettingsActions } from './assistant-settings.state';

export const loadHrAssistantSettingsEffect = createEffect(
  (actions$ = inject(Actions), http = inject(AssistantSettingsHttp)) =>
    actions$.pipe(
      ofType(AssistantSettingsActions.fetch),
      switchMap(() =>
        http.fetch().pipe(
          map(payload => AssistantSettingsActions.fetchSuccess({ payload })),
          catchError((error: HttpErrorResponse) =>
            of(AssistantSettingsActions.fetchFailed({ payload: error })),
          ),
        ),
      ),
    ),
  { functional: true },
);

export const updateHrAssistantSettingsEffect = createEffect(
  (actions$ = inject(Actions), http = inject(AssistantSettingsHttp)) =>
    actions$.pipe(
      ofType(AssistantSettingsActions.update),
      switchMap(({ payload }) =>
        http.update(payload).pipe(
          map(data => AssistantSettingsActions.updateSuccess({ payload: data })),
          catchError((error: HttpErrorResponse) =>
            of(AssistantSettingsActions.updateFailed({ payload: error })),
          ),
        ),
      ),
    ),
  { functional: true },
);
